import React, { Component } from 'react';
import themes from '@codex/themes';
import { Portal } from '@codex/gadgets';
import { ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';
import { fetchUserEligibilityCheckStatus } from '../../../../../appState/ducks/network';
import PopupMessage from './PopupMessage';
import ButtonWithLoader from './ButtonWithLoader';
import EligibilityCheckButton from './EligibilityCheckButton';
import { getString } from '../../../../../utils/UILocale';

class EligibilityCheckContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.fetchAddToBasketButtonData = this.fetchAddToBasketButtonData.bind(this);
    this.handleOnPopupClose = this.handleOnPopupClose.bind(this);
  }

  componentDidMount() {
    this.fetchAddToBasketButtonData();
  }

  handleOnPopupClose() {
    this.setState({ showErrorPopup: false });
  }

  fetchAddToBasketButtonData() {
    this.setState({
      popupMessageData: getString('component.eligibilityCheck.getCheckoutData'),
      showErrorPopup: false,
      dataLoaded: false,
      showEligibilityButton: false
    });

    fetchUserEligibilityCheckStatus()
      .then((data) => {
        const { checkoutBlock } = data;
        const { addToBasket, eligibilityCheck } = checkoutBlock;

        if (addToBasket === eligibilityCheck) {
          this.setState({ showErrorPopup: true });
          return;
        }

        this.setState({
          dataLoaded: true
        });

        if (eligibilityCheck && this.state.popupMessageData) {
          this.setState({
            dataLoaded: true,
            showEligibilityButton: true
          });
        } else {
          this.props.initAddToBasketButton();
        }
      })
      .catch(() => {
        this.setState({ showErrorPopup: true });
      });
  }

  createButtons() {
    const { dataLoaded, showEligibilityButton } = this.state;
    return Array.from(document.querySelectorAll('[data-component="popup-attach"]'))
      .map((node, index) => (
        <Portal key={index} domNode={node}>
          <>
            {!dataLoaded && <ButtonWithLoader />}
            {showEligibilityButton && <EligibilityCheckButton />}
          </>
        </Portal>
      ));
  }

  render() {
    const { showErrorPopup, popupMessageData } = this.state;
    return (
      <ThemeProvider theme={themes.currys}>
        <>
          {this.createButtons()}
          {showErrorPopup && (
            <PopupMessage
              {...popupMessageData}
              onClose={this.handleOnPopupClose}
              onTryAgain={this.fetchAddToBasketButtonData}
            />
          )}
        </>
      </ThemeProvider>
    );
  }
}

EligibilityCheckContainer.displayName = 'EligibilityCheckContainer';

EligibilityCheckContainer.propTypes = {
  initAddToBasketButton: PropTypes.func.isRequired
};

export default EligibilityCheckContainer;
